import React, { useCallback, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import moment from "moment";
import { useTranslation } from "react-i18next";

import { IFacility } from "api/rpc/2022-09/clientAdmin/facility/facility";

import { filterHistoryAddItem, filterHistoryCreate } from "redux/actions/filters/filterHistory";

import { useAppDispatch, useAppSelector } from "hooks/redux";
import { valueToString } from "helpers/Helpers";
import { LocaleCurrency } from "helpers/Locale";

import Avatar from "components/avatar/Avatar";
import { Badge } from "components/badge/Badge";
import Icon from "components/icon/Icon";
import DataTable from "components/dataTable/DataTable";

import "./payoutsTable.scss";
import { ITransaction, ITransactionList } from "pages/secure/facility/settings/payouts/PayoutsInfo";

type TTransactionsTableProps = {
  /** Passing undefined triggers Spin component */
  payOuts: ITransactionList;
  tableLimit: number;
  tableOffset: number;
  handleTableOffset: (direction: "prev" | "next") => void;
  // handleTableNavigation?: (transaction_id: number) => void;
};

const OFFSET_HISTORY_KEY = "facility_payout_offset";
export default function TransactionsTable(props: TTransactionsTableProps) {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const location = useLocation<{ params: { transactionId: number } }>();

  const dispatch = useAppDispatch();
  const filterHistoryStore = useAppSelector(store => store.filterHistoryStore);

  useEffect(() => {
    if (filterHistoryStore[OFFSET_HISTORY_KEY] === undefined) {
      dispatch(filterHistoryCreate(OFFSET_HISTORY_KEY));
    }
  }, []);

  const elementScrollRef = useCallback(element => {
    const locationState = location.state;
    if (element !== null && locationState?.params?.transactionId) {
      if (element?.id === locationState?.params?.transactionId) {
        element?.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, []);

  return (
    <DataTable
      className="transactions-table"
      columns={[
        { label: t("secure.facility.settings.payouts.payouts_info.012") },
        { label: t("secure.facility.settings.payouts.payouts_info.013") },
        { label: t("secure.facility.settings.payouts.payouts_info.014") },
        { label: t("secure.facility.settings.payouts.payouts_info.015") },
        { label: t("secure.facility.settings.payouts.payouts_info.016") },
        { label: t("secure.facility.settings.payouts.payouts_info.017") },
      ]}
      loading={props.payOuts?.transactions === null}
      footer={
        props.payOuts?.transactions?.length > props.tableLimit
          ? {
              tableLimit: props.tableLimit,
              tableOffset: props.tableOffset,
              disableNextOffset:
                !props.payOuts.transactions || !(props.payOuts.transactions?.length === props.tableLimit),
              handleTableOffset: props.handleTableOffset,
            }
          : null
      }
    >
      {props.payOuts?.transactions?.map((transaction, index) => (
        <tr key={index}>
          <td>${transaction.amount}</td>
          <td>${transaction.fee}</td>
          <td>${transaction.net}</td>
          <td>{transaction.currency}</td>
          <td>{moment(transaction.processed_at).format("LLL")}</td>
          <td>{transaction.available_on}</td>
        </tr>
      ))}
    </DataTable>
  );
}
